import { ElementRef, Injectable } from '@angular/core';
import { statusCode } from '@shared/helpers/constants';
import { ApiprocedureService } from '@shared/java/apiprocedure.service';
import { LoggedUserDetails } from '@shared/models/user.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CasedashboardService {
  editDueDateResponse = {};
  storedData: any;
  getUserDetails: LoggedUserDetails;
  loggedInUserName: string;
  loggedInUserFirstName: string;
  loggedUserLastName: string;
  modifiedDueDate: string | number | Date;
  constructor(
    private apiProcedureService: ApiprocedureService,
  ) {
  }
  public getCaseStatus(status) {
    let key = status.toUpperCase();
    if (statusCode.hasOwnProperty(key)) {
      return statusCode[key];
    }
  }

  public getCaseDashboardDetails(params): Observable<any> {
    return this.apiProcedureService.getCaseDBDetails(params);
  }

  public editDueDate(params): Observable<any> {
    return this.apiProcedureService.editDueDate(params);
  }

  public getCasedetails(caseId): Observable<any> {
    return this.apiProcedureService.getCasedetails(caseId)
  }

  public getFacilitydetails(facilityId): Observable<any> {
    return this.apiProcedureService.getFacilityDetails(facilityId)
  }

  public getExportAuditLogsDateService(params): Observable<any> {
    return this.apiProcedureService.getExportAuditLogsDateService(params.selectedStart, params.selectedEnd)
  }

  public getDownloadAuditLogsDateService(fileName, ranges): Observable<any> {
    return this.apiProcedureService.getDownloadAuditLogsDateService(fileName, ranges)
  }

  public exportAuditLogService(caseId): Observable<any> {
    return this.apiProcedureService.exportAuditLogService(caseId)
  }

  public updateCaseDetails(params): Observable<any> {
    return this.apiProcedureService.updateCaseDetails(params)
  }

  public getFilterValuesImage(statCode): Observable<any> {
    return this.apiProcedureService.getFilterValuesImage(statCode)
  }

  public getFilterValuesClaimant(params): Observable<any> {
    return this.apiProcedureService.getFilterValuesClaimant(params.statuscodes, params.casecategory)
  }

  public getFilterValuesCaseDB(userName): Observable<any> {
    return this.apiProcedureService.getFilterValuesCaseDB(userName)
  }

  public getLoggedInDetails(UserName): Observable<any> {
    return this.apiProcedureService.getLoggedInDetails(UserName)
  }

  public auditLogActivity(params): Observable<any> {
    return this.apiProcedureService.auditLogActivity(params)
  }
  public auditLogInDUU(params): Observable<any> {
    return this.apiProcedureService.auditLogInDUU(params)
  }

  
  public ClearFilterData() {
    if (this.storedData != undefined) {
      this.clearArray(this.storedData.imagecenter);
      this.clearArray(this.storedData.assigned);
      this.clearArray(this.storedData.status);
      this.clearArray(this.storedData.anatomy);
      this.clearArray(this.storedData.type);
      this.storedData.completedateEnd = undefined;
      this.storedData.completedateStart = undefined;
      this.storedData.duedateStart = undefined;
      this.storedData.duedateEnd = undefined;
    }
  }
  clearArray(Arr) {
    let dataArray = Arr;
    if (dataArray != undefined) {
      dataArray.map((data, i) => {
        dataArray[i].isSelected = false;
      });
    }
  }
  newFormatedDate(inputDate) {
    let date = new Date(inputDate),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    let myformatedDate = [mnth, day, date.getFullYear()].join('/');
    return myformatedDate;
  }
  public checkEditPermission(caseId,action): Observable<any> {
    return this.apiProcedureService.checkEditPermission(caseId,action);
  }

  customEllipsisHandler(container: ElementRef<any>): boolean {
    return container.nativeElement.children[0].scrollWidth > container.nativeElement.clientWidth;
  }
}